import { ColumnsType, ColumnType } from 'antd/lib/table';

// eslint-disable-next-line @typescript-eslint/ban-types
export function massageTableColumns<RecordType extends object>(
  columns: ColumnsType<RecordType>,
  disabledColumnsDataIndex: string[] = []
): ColumnsType<RecordType> {
  return columns.map(col => {
    const { dataIndex } = col as ColumnType<RecordType>;
    const key = Array.isArray(dataIndex) ? dataIndex.join('.') : dataIndex;

    const isDisabled = disabledColumnsDataIndex?.includes(dataIndex as string);

    return {
      key,
      className: `tw-whitespace-nowrap ${
        isDisabled ? 'tw-bg-gray-100 tw-cursor-not-allowed tw-opacity-70' : ''
      }`,
      onHeaderCell: () => ({
        className: 'tw-whitespace-nowrap tw-bg-transparent tw-cursor-auto',
      }),
      ...col,
    } as ColumnType<RecordType>;
  });
}
